import { Injectable } from "@angular/core";
import Swal from "sweetalert2";
import { TokenCookieService } from "./token-storage-cookies.service";

@Injectable({
  providedIn: "root",
})
export class IdleTimer {
  private timeout: number = 600; 
  private onTimeout: Function;
  private lastActivityTime: number;
  private interval: any;
  private alertInstance: any;

 
  private eventHandler = () => {
    this.lastActivityTime = Date.now();
  };

  constructor(private tokenCookieService: TokenCookieService) {}

  start({ timeout = 600, onTimeout }) {
    const { getUser } = this.tokenCookieService;
    const currentUser = getUser();

    if (currentUser) {
      this.timeout = timeout;
      this.onTimeout = onTimeout;
      this.lastActivityTime = Date.now();

      this.tracker();
      this.startInterval(); 
    }
  }

  startInterval() {
    this.interval = setInterval(() => {
      const idleSeconds = (Date.now() - this.lastActivityTime) / 1000;
      const remaining = this.timeout - idleSeconds;

      // console.log(`Idle for: ${idleSeconds.toFixed(1)}s`);

      if (remaining <= this.timeout * 0.1 && !this.alertInstance) {
        this.showWarningAlert(remaining);
      }

      if (remaining <= 0) {
        if (this.onTimeout) {
          console.log("IdleTimer: Timeout expired, logging out...");
          this.onTimeout();
          this.clear();
        }
      } else if (this.alertInstance) {
        this.updateAlertTimeLeft(remaining);
      }
    }, 1000);
  }

  showWarningAlert(timeLeft: number) {
    this.alertInstance = Swal.fire({
      title: "Warning!",
      text: `The system will sign you out in the next ${timeLeft.toFixed(0)} seconds!`,
      icon: "warning",
      timer: timeLeft * 1000,
      timerProgressBar: true,
      showCancelButton: true,
      confirmButtonText: "Stay Logged In",
      cancelButtonText: "Sign Out",
      willClose: () => {
        this.alertInstance = null;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.lastActivityTime = Date.now();
      } else {
        if (this.onTimeout) {
          this.onTimeout();
          this.clear();
        }
      }
    });
  }

  updateAlertTimeLeft(timeLeft: number) {
    if (this.alertInstance) {
      Swal.update({
        text: `The system will sign you out in the next ${timeLeft.toFixed(0)} seconds!`,
      });
    }
  }

  tracker() {
   
    window.addEventListener("mousemove", this.eventHandler);
    window.addEventListener("scroll", this.eventHandler);
    window.addEventListener("keydown", this.eventHandler);
    window.addEventListener("click", this.eventHandler);
    window.addEventListener("mousedown", this.eventHandler);
    window.addEventListener("touchstart", this.eventHandler);
  }

  clear() {
    clearInterval(this.interval);

    window.removeEventListener("mousemove", this.eventHandler);
    window.removeEventListener("scroll", this.eventHandler);
    window.removeEventListener("keydown", this.eventHandler);
    window.removeEventListener("click", this.eventHandler);
    window.removeEventListener("mousedown", this.eventHandler);
    window.removeEventListener("touchstart", this.eventHandler);

    if (this.alertInstance) {
      this.alertInstance.close();
    }
  }



 reset(): void {
 
  this.lastActivityTime = Date.now();
}

stop(): void {
  this.clear(); 
}

}



